export default {
    news: {
        'loading': false,
        'list': [],
    },
};